// extracted by mini-css-extract-plugin
module.exports = {"wrap":"article-module--wrap--3-XgB","header":"article-module--header--2nPTC","content":"article-module--content--6hSHq","bio":"article-module--bio--2NPQ-"};